import React from 'react';
import { isNil } from 'lodash';
import Panel from '../../../../../components/outline/Panel';
import SelectForm from '../../../../../components/form/SelectForm';
import InputForm from '../../../../../components/form/InputForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import {
  MAXIMUM_NUMBER_OF_POINT_CAUSE_INPUT_TEXT,
  POINT_LOG_TYPE,
  POINT_LOG_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/pointConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './PointCauseSaveInfo.scss';

const PointCauseSaveInfo = (props) => {
  const { form, setData } = props;

  return (
    <Panel className="point-cause-save-info">
      <div className="panel-header">
        <div className="title">포인트 사유 정보</div>
      </div>

      <div className="panel-body">
        {/*내역 종류*/}
        <SelectForm
          className="point-cause-type"
          label="내역 종류"
          form={form}
          name="type"
          list={POINT_LOG_TYPE_SELECT_LIST}
          initialValue={null}
          rules={[
            formRequiredRules(true, REQUIRED_MSG, false),
            {
              validator: (rule, value, cb) => {
                if (value < POINT_LOG_TYPE.SAVE || value > POINT_LOG_TYPE.USE) {
                  cb('필수 값입니다.');
                }
                cb();
              },
            },
          ]}
          onChange={(value) => {
            setData({
              path: ['type'],
              value,
            });
          }}
        />

        {/*적립/사용처*/}
        <InputForm
          className="point-cause"
          label="적립/사용처"
          form={form}
          name="cause"
          rules={[
            formRequiredRules(true, REQUIRED_MSG, false),
            {
              validator: (rule, value, cb) => {
                if (isNil(value)) {
                  cb('필수 값입니다.');
                }
                cb();
              },
            },
          ]}
          onChange={(value) => {
            setData({
              path: ['cause'],
              value,
            });
          }}
          maxLength={MAXIMUM_NUMBER_OF_POINT_CAUSE_INPUT_TEXT}
        />
      </div>
    </Panel>
  );
};

export default PointCauseSaveInfo;
